import React from 'react';
import Clamp from 'shiitake';
import { Icon } from 'ui';

const InsightsTableRow = ({ number, item, amount, href, icon, amountHREF }) => {
  const Wrapper = href ? 'a' : 'span';
  const AmountWrapper = amountHREF ? 'a' : 'span';

  return (
    <li className="d-f jc-sb ai-c c-brand-night fz-bigger">
      <span className="d-f ai-c p-8">
        <span className="c-gray-dark mr-8 fz-sm fw-b">{number}</span>
        <Wrapper href={href}>
          <Clamp lines={1}>{item}</Clamp>
        </Wrapper>
      </span>
      <AmountWrapper className="p-8 fw-b pl-16 f-sh-0" href={amountHREF}>
        {amount.toLocaleString()} {icon && <Icon name={icon} />}
      </AmountWrapper>
    </li>
  );
};

export default InsightsTableRow;
